import {Button, message, Modal, Tabs} from 'antd';
import {formatTimestamp} from "../../helpers/time";
import {formatFileSize, getId} from "../../helpers/file";
import i18n from '../../i18n';

export const showUsageInfo = () => {
  const uid = getId();
  const t = (key: string) => i18n.t(key);
  
  // 重新统计函数
  const handleRefreshStats = () => {
    message.info(t('usageInfo.refreshing'));
    fetch('/img/trigger', { method: 'GET' })
      .then(res => res.json())
      .then(data => {
        if (data.success || data.isSuccess) {
          message.success(t('usageInfo.refreshTriggered'));
        } else {
          message.error(data.message || t('usageInfo.refreshFailed'));
        }
      })
      .catch(() => {
        message.error(t('usageInfo.refreshFailed'));
      });
  };
  
  // 获取在线情况
  const fetchOnlineInfo = fetch('/img/onlineInfo').then(res => res.json());
  
  // 获取存储统计
  const fetchStorageStats = fetch('/img/stat').then(res => res.json());
  
  Promise.all([fetchOnlineInfo, fetchStorageStats])
    .then(([onlineData, storageData]) => {
      const items = [
        {
          key: '1',
          label: t('usageInfo.onlineStatus'),
          children: (
            <>
              {
                Object.entries(onlineData)
                  .map(([key, value]) => 
                    <p key={key}>
                      {key == uid ? t('usageInfo.currentDevice') : key}: <b>{formatTimestamp(value as string)}</b>
                    </p>
                  )
              }
            </>
          ),
        },
        {
          key: '2',
          label: t('usageInfo.storageStats'),
          children: (
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                <p style={{ color: '#666', fontSize: '12px', margin: 0 }}>
                  * {t('usageInfo.offlineStats')}
                </p>
                <Button size="small" type="primary" onClick={handleRefreshStats}>
                  {t('usageInfo.refreshStats')}
                </Button>
              </div>
              {storageData ? (
                Object.entries(storageData).map(([key, value]) => (
                  <p key={key}>
                    {key === 'totalSize' ? t('usageInfo.totalSize') : key}: <b>
                      {key === 'totalSize' && typeof value === 'number' 
                        ? formatFileSize(value)  as any
                        : value}
                    </b>
                  </p>
                ))
              ) : (
                <p>{t('usageInfo.noStorageStats')}</p>
              )}
            </div>
          ),
        },
      ];

      Modal.info({
        title: t('usageInfo.title'),
        width: 600,
        content: (
          <Tabs defaultActiveKey="1" items={items} />
        ),
      });
    })
    .catch(error => {
      console.error('Failed to fetch usage info:', error);
      Modal.error({
        title: t('usageInfo.error'),
        content: t('usageInfo.fetchFailed'),
      });
    });
};